import { useMemo } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useSeoExtras } from '../context/SiteSeoContext';
import { buildRegionalSeoAlternates } from '../utils/seoAlternates';

/**
 * Hreflang props for static/list pages (one URL per country market when regional variants are enabled).
 * @param {string} pagePath - e.g. '/', '/categories', '/about'
 */
export function useRegionalSeo(pagePath = '/') {
  const { language, region, availableRegions } = useLanguage();
  const { includeRegionalVariants } = useSeoExtras();

  return useMemo(() => {
    const regionalVariants = includeRegionalVariants !== false;
    const { availableLanguages, alternateUrls } = buildRegionalSeoAlternates(
      availableRegions,
      pagePath,
      regionalVariants
    );
    const regionCode = String(region?.code || 'US').toLowerCase();
    const currentTag = regionalVariants
      ? `${language}-${regionCode}`.toLowerCase()
      : language;
    const pageUrl = alternateUrls[currentTag] || alternateUrls[language] || pagePath;
    return { language, availableLanguages, alternateUrls, pageUrl };
  }, [language, region, availableRegions, pagePath, includeRegionalVariants]);
}
